<div class="bg-message" *ngIf="showExpirationMessage">
  <div class="session-expiration">
    <h4 [innerHtml]="'sessionExpired.msg' | translate"></h4>
    <div class="session-expiration__actions">
      <button type="button" mat-stroked-button class="session-expiration__secondary" (click)="handleStopSession()">
        {{ 'sessionExpired.no' | translate }}
      </button>
      <button type="button" mat-raised-button color="primary" (click)="handleContinueSession()">
        {{ 'sessionExpired.yes' | translate }}
      </button>
    </div>
  </div>
</div>
